///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const Check = ({
  height,
  title = messages.check.defaultMessage,
  width,
  fill = "#27D434",
  ...props
}) => {
  return (
    <svg
      aria-labelledby="check-icon"
      height={height}
      viewBox={`0 0 24 24`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="check">{title}</title>
      <path
        d="M9.994 14.257L7.2 11.574 6 12.726l3.994 3.836 8.236-7.91-1.2-1.152z"
        fill={fill}
      />
    </svg>
  );
};

export default Check;
